import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";
import edenred from '../../Assets/Icons/edenred.svg'
import applePay from '../../Assets/Icons/applePay.svg'
import googlePay from '../../Assets/Icons/googlePay.svg'
import mastercard from '../../Assets/Icons/mastercard.svg'
import visa from '../../Assets/Icons/visa.svg'
import add from '../../Assets/Icons/add.svg'
import selected from '../../Assets/Icons/selected.svg'
import arrowRight from '../../Assets/Icons/arrowRight.svg'
import trash from '../../Assets/Icons/trash.svg'

import './PaiementPage.scss'
import {useNavigate} from "react-router-dom";
import {useStripe} from "@stripe/react-stripe-js";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {UserModel} from "../../Models/UserModel";
import {usePostOrder} from "../../hooks/usePostOrder";
import Success from "../../Components/Success/Success";
import check from "../../Assets/Icons/check.svg";
import {OrderModel} from "../../Models/OrderModel";
import {usePaymentWithCard} from "../../hooks/usePaymentWithCard";
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import {useError} from "../../hooks/useError";
import Error from "../../Components/Error/Error";
import axios from "axios";
import {SendOrderMailRequest} from "../../Models/request/SendOrderMail";
import {OrderResponseModel} from "../../Models/OrderResponseModel";
import {useDeleteCard} from "../../hooks/useDeleteCard";
import {useModal} from "../../hooks/useModal";
import Confirm from "../../Components/Confirm/Confirm";
import {StadiumModel} from "../../Models/StadiumModel";
import {setPanier, setTimeCreationPanier} from "../../store/actions";
import {CarteBancaireModel} from "../../Models/CarteBancaireModel";
import {
    PaymentRequestPaymentMethodEvent,
} from "@stripe/stripe-js/types/stripe-js/payment-request";
import {useCardTypeAccepted} from "../../hooks/useCardTypeAccepted";
import {AcceptedCardResponseModel} from "../../Models/AcceptedCardResponseModel";
import {useAddEdenred} from "../../hooks/useAddEdenred";
import {useValidateCartBeforePayment} from "../../hooks/useValidateCartBeforePayment";
import {useTranslation} from "react-i18next";
import {mapApiError} from "../../i18n/mapApiError";
import {getCurrentLanguage} from "../../i18n/i18n";

interface SelectedMethodModel {
    type: 'native' | 'cb',
    cb?: CarteBancaireModel
}

let paymentId: string | undefined = undefined
let edenredToken: string | undefined = undefined
let cb: any = undefined
const PaiementPage: React.FC = ({}) => {
    const {t} = useTranslation(['paiement', 'common'])
    const dispatch = useDispatch()
    const stripe = useStripe();
    const navigate = useNavigate()

    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const user = useSelector<StateModel, UserModel | undefined>(state => state.user)
    const stade = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)
    const selectedCard = useSelector<StateModel, CarteBancaireModel | undefined>(state => state.selectedCard)

    const [showBtmSheet, setShowBtmSheet] = useState<boolean>(false)
    const [paymentRequest, setPaymentRequest] = useState<any>(null);
    const [nativePayment, setNativePayment] = useState<string>('');
    const [selectedMethod, setSelectedMethod] = useState<SelectedMethodModel>({type: 'cb', cb: selectedCard});
    const [indexCbToDelete, setIndexCbToDelete] = useState<number | undefined>();
    const payWithCard = usePaymentWithCard()
    const loader = useLoader()
    const postOrder = usePostOrder(loader.show, loader.hide)
    const error = useError()
    const errorDeleteCB = useModal()
    const confirmDeleteCB = useModal()
    const successDeleteCB = useModal()
    const deleteCard = useDeleteCard(loader.show, loader.hide, successDeleteCB.open, errorDeleteCB.open, user)
    const cardTypeAccepted = useCardTypeAccepted()
    const validateCartBeforePayment = useValidateCartBeforePayment(loader.show, loader.hide, (message: string) => error.open(message))
    const [addEdenred] = useAddEdenred(
        panier,
        (token: string, authorizationId: string) => {
            paymentId = authorizationId
            edenredToken = token
            loader.hide()
            setShowBtmSheet(true)
        },
        () => error.open(t('paiement:errors.tryAnotherPaymentMethod')));

    useEffect(() => {
        if (user?.cartesBancaires && user.cartesBancaires.length > 0 && !selectedCard) {
            setSelectedMethod({type: 'cb', cb: user.cartesBancaires[0]})
        }
    }, [user, selectedCard])


    useEffect(() => {
        if (stripe && panier) {
            const pr = stripe.paymentRequest({
                country: 'FR',
                currency: 'eur',
                total: {
                    label: 'Bart topivo',
                    amount: panier.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
                },
                displayItems: panier.orderProducts?.map(p => {
                    return {amount: p.totalPriceTTC ? p.totalPriceTTC * 100 : 0, label: p.name || ''}
                }),
                requestPayerName: true,
                requestPayerEmail: true,
            });

            // Check the availability of the Payment Request API.
            void pr.canMakePayment().then(result => {
                if (result) {
                    setPaymentRequest(pr);
                    setNativePayment(result.applePay ? 'applePay' : result.googlePay ? 'googlePay' : '')
                }
            });
        }
    }, [stripe, panier]);

    useEffect(() => {
        if (paymentRequest) {
            paymentRequest.on('paymentmethod', function (event: PaymentRequestPaymentMethodEvent) {
                void cardTypeAccepted(event.paymentMethod.card?.brand)
                    .then((res: AcceptedCardResponseModel) => {
                        if (!res.isAccepted) {
                            loader.hide()
                            error.open(mapApiError(res.message))
                        } else {
                            cb = event.paymentMethod.card;
                            if (panier) {
                                const body = {
                                    id: `${stade?.reference}${panier.reference}`,
                                    amount: panier.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
                                    customerId: user?.stripeId,
                                    cardId: event.paymentMethod.id,
                                    description: `${stade?.reference} commande #${panier.reference}`,
                                    country: "FR",
                                    ht: panier.totalPriceHT ? +panier.totalPriceHT * 100 : 0,
                                }
                                payWithCard(
                                    body,
                                    (id) => {
                                        paymentId = id
                                        edenredToken = undefined
                                        event.complete('success');
                                        setShowBtmSheet(true)
                                    },
                                    () => {
                                        event.complete('fail');
                                    }
                                )
                            }
                        }
                    })
                // event.paymentMethod is available
            });
        }
    }, [paymentRequest])

    const payNative = () => {
        paymentRequest.show()
    }

    const payCb = (cardId: string) => {
        if (panier) {
            loader.show()
            const body = {
                id: `${stade?.reference}${panier.reference}`,
                amount: panier.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
                customerId: user?.stripeId,
                cardId,
                description: `${stade?.reference} commande #${panier.reference}`,
                country: "FR",
                ht: panier.totalPriceHT ? +panier.totalPriceHT * 100 : 0,
            }
            payWithCard(
                body,
                (id) => {
                    paymentId = id
                    edenredToken = undefined
                    loader.hide()
                    setShowBtmSheet(true)
                },
                () => {
                    loader.hide()
                }
            )
        }
    }

    const onValidate = () => {
        void validateCartBeforePayment().then((hasChanged: boolean) => {
            if (hasChanged) {
                return
            }
            if (selectedMethod.type === 'native') {
                payNative()
            } else {
                void cardTypeAccepted(selectedMethod.cb?.brand)
                    .then((res: AcceptedCardResponseModel) => {
                        if (!res.isAccepted) {
                            loader.hide()
                            error.open(mapApiError(res.message))
                        } else {
                            cb = user?.cartesBancaires.find(c => c.stripeId === selectedMethod.cb?.stripeId)
                            payCb(selectedMethod.cb?.stripeId || '')
                        }
                    })
            }
        })
    }

    const onEdenredClick = () => {
        void validateCartBeforePayment().then((hasChanged: boolean) => {
            if (!hasChanged) {
                addEdenred()
            }
        })
    }

    const onAjoutCard = () => {
        void validateCartBeforePayment().then((hasChanged: boolean) => {
            if (!hasChanged) {
              navigate('/ajout-carte')
            }
        })
    }

    const formatPickup = (pickup?: string) => {
        if (pickup) {
            const splited = pickup.split(" ")
            return splited[splited.length - 1]
        }
        return ''
    }

    const computeTvas = (orderProducts: any[]) => {
        const tvas: { rate: string, total: number }[] = []
        orderProducts.forEach((p) => {
            if (p.tvaRate && p.totalTva) {
                const existingTva = tvas.find(t => t.rate === p.tvaRate)
                if (existingTva) {
                    existingTva.total += p.totalTva
                } else {
                    tvas.push({rate: p.tvaRate, total: p.totalTva})
                }
            }
        })
        return tvas
    }

    const onPostOrder = () => {
        postOrder(
            (res: OrderResponseModel) => {
                const body: SendOrderMailRequest = {
                    date: new Date(),
                    total: res.totalPriceTTC ? +res.totalPriceTTC : 0,
                    totalHt: res.totalPriceHT ? +res.totalPriceHT : 0,
                    nomUser: user?.prenom || '',
                    pickupZone: formatPickup(res.pdv?.bartPickup?.name),
                    reference: res.reference,
                    payment: {brand: cb?.brand || '', last4: cb?.last4 || ''},
                    tvas: computeTvas(res.orderProducts ?? []),
                    items: res.orderProducts?.map((p: any) => {
                        return {
                            nom: p.name,
                            quantity: p.quantity,
                            total: p.totalPriceTTC,
                            tvaRate: p.tvaRate || 0,
                            totalTva: p.totalTva || 0
                        }
                    }) || []
                }
                void axios.post(`${process.env.REACT_APP_BART_URL}/emails/send_order_email/${user?.email}?lang=${getCurrentLanguage()}`, body)
                dispatch(setPanier(undefined))
                dispatch(setTimeCreationPanier(undefined))
                navigate('/qrCode', {
                    state: {
                        reference: res.reference,
                        pickup: res.pdv?.bartPickup?.name,
                        total: res.totalPriceTTC,
                        affluence: res.pdv?.affluence
                    }
                })
            },
            (err: any) => {
                if (edenredToken) {
                    const body = {
                        token: edenredToken,
                        authorizationId: paymentId,
                        amount: panier?.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
                    }
                    void axios.post(`${process.env.REACT_APP_BART_URL}/edenred/refund-transaction`, body)
                } else {
                    void axios.delete(`${process.env.REACT_APP_BART_URL}/stripe/${paymentId}/refund`)
                }
                setShowBtmSheet(false)
                error.open(mapApiError(err.response.data.errors[0].message))
            }
        )
    }

    const onDeleteCb = (index: number) => {
        setIndexCbToDelete(index)
        confirmDeleteCB.open()
    }

    const handleDeleteCb = () => {
        confirmDeleteCB.close()
        if (indexCbToDelete !== undefined && user?.cartesBancaires) {
            deleteCard(user?.cartesBancaires[indexCbToDelete], indexCbToDelete)
        } else {
            errorDeleteCB.open()
        }
        setIndexCbToDelete(undefined)
    }

    return (
        <BasePage showBack title={t('paiement:title')} backDelta={-2} onLogout={() => navigate(-1)}>
            <div className="paiement">
                <p className="paiement--text">{t('paiement:subtitle')}</p>
                {
                    paymentRequest && nativePayment === 'applePay' && <div className="paiement__row"
                                                                           onClick={() => paymentRequest && nativePayment === 'applePay' && setSelectedMethod({type: 'native'})}>
                        <img src={applePay} alt="apple pay" className="paiement__row--img"/>
                        <div className="paiement__row__infos">
                            <p className="paiement__row__infos--name">Apple pay</p>
                            <p className="paiement__row__infos--info">{paymentRequest && nativePayment === 'applePay' ? t('paiement:available') : t('paiement:unavailable')}</p>
                        </div>
                        {selectedMethod.type === 'native' && nativePayment === 'applePay' &&
                            <img src={selected} alt="selected" className="paiement__row--right"/>}
                    </div>
                }
                {
                    paymentRequest && nativePayment === 'googlePay' && <div className="paiement__row"
                                                                            onClick={() => paymentRequest && nativePayment === 'googlePay' && setSelectedMethod({type: 'native'})}>
                        <img src={googlePay} alt="google pay" className="paiement__row--img"/>
                        <div className="paiement__row__infos">
                            <p className="paiement__row__infos--name">Google pay</p>
                            <p className="paiement__row__infos--info">{paymentRequest && nativePayment === 'googlePay' ? t('paiement:available') : t('paiement:unavailable')}</p>
                        </div>
                        {selectedMethod.type === 'native' && nativePayment === 'googlePay' &&
                            <img src={selected} alt="selected" className="paiement__row--right"/>}
                    </div>
                }
                {
                    user?.cartesBancaires.map((cb, index) => (
                        <div key={index} className="paiement__row">
                            <div className="paiement__row__left" onClick={() => setSelectedMethod({type: 'cb', cb})}>
                                <img src={cb.brand === "mastercard" ? mastercard : visa} alt="mastercard"
                                     className="paiement__row--img"/>
                                <div className="paiement__row__infos">
                                    <p className="paiement__row__infos--name">•••• {cb.last4}</p>
                                    <p className="paiement__row__infos--info">{cb.brand}</p>
                                </div>
                            </div>
                            <div className="paiement__row__actions">
                                {
                                    selectedMethod.cb?.stripeId === cb.stripeId &&
                                    <img src={selected} alt="selected"/>
                                }
                                <img src={trash} alt="selected" onClick={() => onDeleteCb(index)}/>
                            </div>
                        </div>
                    ))
                }
                <div className="paiement__row" onClick={onAjoutCard}>
                    <img src={add} alt="add" className="paiement__row--img"/>
                    <div className="paiement__row__infos">
                        <p className="paiement__row__infos--name">{user?.id ? t('paiement:addCard') : t('paiement:payByCard')}</p>
                    </div>
                    <img src={arrowRight} alt={t('common:alt.forward')} className="paiement__row--right"/>
                </div>
                <div className="paiement__row" onClick={onEdenredClick}>
                    <img src={edenred} alt="edenred" className="paiement__row--img"/>
                    <div className="paiement__row__infos">
                        <p className="paiement__row__infos--name">Edenred</p>
                    </div>
                </div>
            </div>
            <div className="paiementFooter">
                <BaseButton disabled={selectedMethod.type === 'cb' && !selectedMethod.cb} onClick={onValidate}
                            text={t('common:actions.validate')}
                            className="paiementFooter--btn"/>
            </div>
            <Success show={showBtmSheet} close={onPostOrder} title={t('paiement:successTitle')} icone={check}/>
            <Error show={error.visible} close={error.close} title={t('common:errors.generic')} subTitle={error.message}/>
            <Confirm visible={confirmDeleteCB.visible} onOk={handleDeleteCb} onCancel={confirmDeleteCB.close}
                     title={t('paiement:confirmDeleteCard')}/>
            <Success show={successDeleteCB.visible} close={successDeleteCB.close} title={t('paiement:cardDeleted')}
                     icone={check}/>
            <Error show={errorDeleteCB.visible} close={errorDeleteCB.close} title={t('common:errors.generic')}
                   subTitle={t('common:errors.tryAgainLater')}/>
            <Loader visible={loader.visible}/>
        </BasePage>
    )
}

export default PaiementPage;
